<template>
 <div class="cascade-list">
   <div @mouseover="clearTimer" @mouseout="setTimer" v-for="(item, index) in items" class="item" :style="{width:item.width+'px',height:item.height+'px',left:item.left+'px',bottom:item.bottom+'px','z-index':item.zIndex,opacity:item.opacity,'background-color':rlist[index].color
  }">


    <span :style="{'line-height':item.height+'px'}">{{rlist[index].content}}</span>
  </div>
 </div>
</template>

<script>
export default {
  props:{
    curWidth:{
      type:Number,
      default:700
    },
    curHeight:{
      type:Number,
      default:440
    },
    allWidth:{
      type:Number,
      default:1800
    },
    allHeight:{
      type:Number,
      default:440
    },
    list:{
      type:Array,
      default:[
        {content:1,color:'red'},
        {content:2,color:'green'},
        {content:3,color:'blue'},
        {content:4,color:'#66CC66'},
        {content:5,color:'black'},
        {content:6,color:'blue'},{content:1,color:'red'},
        {content:2,color:'green'},
        {content:3,color:'blue'},
        {content:4,color:'#66CC66'},
        {content:5,color:'black'},
        {content:6,color:'blue'}
      ]
    },
    scale:{
      type:Number,
      default:0.8
    },
    dir: {//旋转方向
      type:String,
      default:'right'
    }
  },
  data () {
    return {
      items:[],
      rlist:[],
      timer:null,
    }
  },
  methods:{
    copyArr(arr){
      return arr.map((e)=>{
        if(typeof e === 'object'){
          return Object.assign({},e)
        }else{
          return e
        }
      })
    },
    initData() {
      var items = [];
      var rlist = this.copyArr(this.list);
      var level = Math.floor(this.list.length/2);
      if(this.list.length%2==0){
        var center = this.list[0];
        rlist.push(Object.assign({},center));
      }

      var lefts = rlist.slice(0,level);
      var rights = rlist.slice(level);
      var that = this;
      var leftGap = (this.allWidth - this.curWidth)/2;
      //console.log(this.allWidth);
      var gap = leftGap/level;
      lefts.forEach(function(e,i){
        var obj = {};
        obj.content = e.content;
        obj.left = i*gap;
        // obj.left=0;
        obj.zIndex = i+1;
        obj.opacity = 1/(level+1-i);
        //	console.log(that.curWidth);
        obj.width = that.curWidth*Math.pow(that.scale,level-i);
        obj.height = that.curHeight*Math.pow(that.scale,level-i);
        obj.bottom = (that.allHeight-obj.height)/2;
        items.push(obj);
      });
      rights.forEach(function(e,i){
        var obj = {};
        obj.content = e.content;
        obj.width = that.curWidth*Math.pow(that.scale,i);
        obj.height = that.curHeight*Math.pow(that.scale,i);
        obj.left = that.allWidth - (level-i)*gap - obj.width;
        // obj.left=100;
        obj.zIndex = level-i+1;
        obj.opacity = 1/(i+1);
        obj.bottom = (that.allHeight-obj.height)/2;
        items.push(obj);
      });

        this.items=items
        this.rlist=rlist
    },
    setTimer () {
      var that = this;
      this.clearTimer();
      function cb(){
        that.timer = setTimeout(function(){
          if(that.dir=="right"){

            var pop = that.items.shift();
            that.items.push(pop);
          }else{
            var pop = that.items.pop();
            that.items.unshift(pop);
          }
          cb();
        },2000);
      }
      cb();
    },
    clearTimer:function(){
      if(this.timer){
        clearTimeout(this.timer);
      }
    },
  },
  created () {
    this.setTimer();
  },
  mounted () {
    this.initData()
  }

}
</script>

<style scoped>
  .cascade-list{
    width:1800px;
    height:440px;
    position:relative;
    margin:0 auto;
  }
  .toggle{
    position:absolute;
    padding:.5em .8em;
    top:0;
    left:0;
  }
  .item{
    box-sizing:border-box;
    border:1px solid #fff;
    position:absolute;
    display:block;
    background-color:blue;
    color:#fff;
    text-align:center;
    transition: all .8s ease;
  }
  .item span{
    transition:inherit;
    font-size:60px;
  }
  .cascade-list .item:nth-child(2n){
    /*
      background-color:red;
      */
  }
</style>
